import { Spinner } from "react-activity";
import { ArrowRight } from "react-feather";
import { Colors } from "../../values/colors";
import { Button } from "../Button";

export const ActionButton = ({ color, onClick, showIcon = true, actionIcon, isLoading, textColor, style, children, type, disabled }) => {

  return (
    <Button
      disabled={isLoading || disabled}
      onClick={onClick}
      color={color || Colors.primary}
      textColor={textColor}
      type={type}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '.75rem 1.5rem',
        backgroundColor: disabled ? Colors.lightGray : color || Colors.primary,
        ...style
      }}
    >
      {children}
      {!isLoading ?
        (showIcon ? (actionIcon || <ArrowRight size={18} style={{ marginLeft: 10 }} />) : null)
        : <Spinner color="#fff" size={12} style={{ marginLeft: 10 }} />
      }
    </Button>

  );

}